<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      dialogIcon="mdi-message-text"
      title="Kommentar"
      subtitle="Legg til en kommentar"
      btnActionName="Lagre"
      :persistent="$vuetify.breakpoint.smAndDown"
      :noClickAnimation="true"
      :showCloseBtn="showCloseBtn"
      @action="save"
    >
      <template v-slot>
        <CommentInpute
          v-model="data"
          :closeDialog="!showDialog"
          :desplayShowToCostomerBtn="desplayShowToCostomerBtn"
          :tagUsers="tagUsers"
        />
      </template>
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import commentApi from "@/api/commentApi";

import { valueTypeObject, CommentObject } from "@/types/commentInterface";
import { KeyValueExtra } from "@/types/keyValue";
import { applicationRecipientType } from "@/types/enums";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import CommentInpute from "@/components/shared/comments/CommentInpute.vue";
import notification from "@/helpers/notification";

export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    context: {
      type: Object as () => valueTypeObject,
    },
    desplayShowToCostomerBtn: {
      type: Boolean,
      default: false,
    },
    tagUsers: {
      type: Array as () => Array<KeyValueExtra>,
    },
  },
  data() {
    return {
      data: {
        visibleToCustomer: false,
        newComment: "",
        text: "",
        attachments: [] as any,
        tags: [] as any,
        applicationRecipientType: applicationRecipientType.External,
      } as CommentObject,
      tags: [],
    };
  },
  watch: {
    value(value) {
      if (!value) {
        this.data = {
          visibleToCustomer: false,
          newComment: "",
          text: "",
          attachments: [] as any,
        } as CommentObject;
      }
    },
  },
  methods: {
    async save() {
      if (this.data.newComment === "") {
        notification.warn("Må legge til kommentar for å lagre!");
      } else {
        this.data.text = this.data.newComment;

        switch (this.context.commentType) {
          case 0:
            this.data.regLineId = this.context.id;
            this.data.commentStatus = this.context.lineStatus;
            break;
          case 1:
            this.data.aberrationId = this.context.id;
            this.data.commentStatus = this.context.commentStatus;
            break;
          case 2:
            this.data.aberrationActionId = this.context.id;
            this.data.commentStatus = this.context.commentStatus;
            break;
        }

        await commentApi.saveComment(this.data).then((response) => {
          this.$emit("commentAdded", response);
        });

        this.showDialog = false;
      }
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    showCloseBtn() {
      return true;
    },
  },
  components: {
    BaseDialog,
    CommentInpute,
  },
});
</script>
